module.exports = __webpack_public_path__ + "static/media/Catalogo-Productos.219838c0.png";